module.exports = __webpack_public_path__ + "img/upload_file.90657ef9.svg";